<div class="order-return p-5">
  <h3 class="mb-5"
    >Return Orders - [Sales Order # {{ currentParentSalesOrder.orderNumber }}]</h3
  >
  <mat-divider class="mb-5 mt-2"></mat-divider>
  <lum-order-return-filters
    class="mb-2"
    [parentSalesOrderId]="parentSalesOrderId"
    (searchEvent)="onSearchEvent($event)"
  ></lum-order-return-filters>
  <ng-container *ngIf="(loading$ | async) === false; else loader">
    <lum-order-return-table
      *ngIf="(orderReturns$ | async)?.length; else noData"
      [orderReturns]="orderReturns"
      [parentSalesOrderId]="parentSalesOrderId"
    ></lum-order-return-table>
    <mat-paginator
      [length]="(pagination$ | async)?.total"
      [pageSize]="(pagination$ | async)?.per_page"
      [pageSizeOptions]="paginationConfig.pageSizeOptions"
      [pageIndex]="((pagination$ | async)?.current_page || 1) - 1"
      (page)="onPaginationEvent($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </ng-container>

  <ng-template #loader> </ng-template>

  <ng-template #noData>
    <div class="text-center p-4">
      <h3>No records available.</h3>
    </div>
  </ng-template>
</div>
